export default "__VITE_ASSET__8UzbyGEk__"